import { useActionLogs } from '@/hooks/useActionLogs'
import { getOpportunityActionLogs } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseOpportunityActionLogsOptions {
  enabled?: boolean
  offset?: number
  limit?: number
}
export function useOpportunityActionLogs(opportunityId: number, options: UseOpportunityActionLogsOptions = {}) {
  const { enabled = true, offset, limit } = options

  return useActionLogs({
    queryKey: queryKeys.opportunity.actionLogs(opportunityId, { offset, limit }),
    fetchFn: () => getOpportunityActionLogs(opportunityId, { offset, limit }),
    enabled: enabled && opportunityId > 0,
  })
}
